import styles from './tabs.module.scss'
import { cn } from 'utils/helpers'

export default function Tabs({ bold, labels, active, setActive, border, className }) {
    return (
        <div className={cn(styles.tabs, border && styles.border, bold && styles.bold, className)}>
            {labels.map((label, k) => (
                <div key={k} onClick={() => setActive(k)} className={cn(styles.tab, active == k && styles.active)}>
                    {label}
                </div>
            ))}
        </div>
    )
}
